<template>
  <div>
    <div
      :class="[gameType === 'MW' ? 'modal modal-game_memory_wizard' : gameType === 'ODD' ? 'modal modal-game_odd_object alternative_flow_odd_modal': 'modal modal-game_spot_difference']"
      :id="[gameType === 'MW' ? 'modal-game_memory_wizard' : gameType === 'ODD' ? 'modal-game_odd_object': 'modal-game_spot_difference']">
      <div class="modal__content won_game_modal">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header modal_ti_header">
          <div class="row gamepage_header">
            <img v-if="gameType === 'MW'" class="gamepage_logo " src="static/images/logo-memory-wizard.png"/>
            <img v-if="gameType === 'ODD'" class="gamepage_logo " src="static/images/logo-odd-object.png"/>
            <img v-if="gameType === 'SD'" class="gamepage_logo " src="static/images/logo-spot-difference.png"/>
            <h1 v-if="gameType === 'MW'">{{ getTranslations.home_game_memory_wizard }}</h1>
            <h1 v-if="gameType === 'ODD'">{{ getTranslations.home_game_odd_game }}</h1>
            <h1 v-if="gameType === 'SD'">{{ getTranslations.home_game_sd_game }}</h1>
            <p>{{ getTranslations.home_modals_post_prize_great_you_won }}</p>
          </div>
        </div>
        <div class="modal__body">
          <h1 class="prize_won_headline">{{ playersDetails.winDTO.name }}</h1>

          <div class="prize_won_image prize_won_image_prize">
            <img :src="playersDetails.winDTO.imageWonUrl"/>
            <div class="prize_won_image prize_won_image_conffeti"></div>
          </div>
          <p class="cta_support">{{ getTranslations.visitor_alternative_to_redeem_login_or_register }}</p>
          <div class="row">
            <div class="col-6">
              <a class="ti_btn--green modal_cta" style="cursor:pointer"
                 @click.prevent="redirect('register')">{{ getTranslations.visitor_visitor_header_register }}</a>
            </div>
            <div class="col-6">
              <a class="ti_btn--green modal_cta trasparent_button" style="cursor:pointer"
                 @click.prevent="redirect('login')">{{ getTranslations.visitor_visitor_header_login }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapGetters, mapMutations, mapState } from 'vuex';
import { GameMixin4 } from '@/common/mixins/game';
import modals from '../../../common/modals';

export default {
  name: 'post-game-prize-visitor',
  mixins: [GameMixin4],
  data() {
    return {
      showedModal: false,
      currentModal: null,
    };
  },
  created() {
    console.log('in PostGamePrize Visitor created hook');
    this.saveUnauthorizedMsisdnAndPrizeIdToCallLSC();
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
      'resetUnauthorizedMsisdn',
      'resetCode',
      'validTransitionForFreeGameMethod',
    ]),
    ...mapMutations('game', [
      'resetGameState',
      'resetPrizeData',
    ]),
    redirect(path) {
      modals.resetAllUserInfo(this);
      if (path === 'login') this.$router.push('/login');
      else this.$router.push('/alternativetwostepregister1');
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('game', [
      'playersDetails',
      'gameType',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeGameProcess/PostGamePrizeVisitor.vue